/**
 * @documental
 * @export Break
 * @name
 * Grid.Break
 */

import { FC } from "react";

/**
 * Specifies a break point within the `Grid`, generating a new row.
 */
export const Break: FC = () => {
  return null;
};
